namespace AgerLMS.LMS {
    export interface OrderRow {
        OrderId?: number;
        OrderGuid?: string;
        OrderState?: OrderStates;
        ConfirmDate?: string;
        ConfirmUserId?: number;
        ItemCount?: number;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace OrderRow {
        export const idProperty = 'OrderId';
        export const nameProperty = 'OrderGuid';
        export const localTextPrefix = 'LMS.Order';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = 'LMS:Order:Read';
        export const updatePermission = '?';

        export declare const enum Fields {
            OrderId = "OrderId",
            OrderGuid = "OrderGuid",
            OrderState = "OrderState",
            ConfirmDate = "ConfirmDate",
            ConfirmUserId = "ConfirmUserId",
            ItemCount = "ItemCount",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
